<template>
	<div>
		<!-- -->
		<div>

				<el-upload v-loading="loading" :element-loading-text="this.$t('userinfo.useravatar.loadingtext')" element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)" style="width: 100%"
				class="avatar-uploader" action="#" :http-request="uploadImg" :show-file-list="false"
					:before-upload="beforeAvatarUpload">
					<img v-bind:src="options.img" :title="this.$t('userinfo.useravatar.beforeupload')" class="img-circle img-lg"
						style="width: 99%; height: 99%;" />
					<div slot="tip" class="el-upload__tip">{{$t('userinfo.useravatar.tip')}}</div>
				</el-upload>


		</div>

	</div>
</template>

<script>
	import store from "@/store";
	import {
		VueCropper
	} from "vue-cropper";

	export default {
		components: {
			VueCropper
		},
		props: {
			user: {
				type: Object
			}
		},
		created() {
			let user = JSON.parse(window.localStorage.getItem("user"));
			this.options.img = user.image;
		},
		computed: {
			routes() {
				return this.$store.state.routes;
			},
			avatorImg: {
				get(){
					return this.$store.state.imageUrl;
				},
				set(val){
					
				}
			}
		},
		watch:{
			avatorImg:{
				handler: function(val, oldVal){
					this.options.img = val;
				},
				immediate: true
			}
		},
		data() {
			return {

				title: "修改头像",
				options: {
					img: '', //裁剪图片的地址
				},
				photo: '',
				loading: false
			};
		},
		methods: {
			beforeAvatarUpload(file) {
				let isLt200k = file.size / 1024 < 200;
				if (!isLt200k) {
					this.$message.error('上传头像图片大小不能超过 200KB!');
					return isLt200k;
				}
				this.photo = file;
			},
			// 上传图片
			uploadImg(data) {
				let formData = new FormData();
				formData.append("file", data.file);
				this.loading = true;
				this.postFormRequest('/tpa-api/admin/updAdminImage', formData).then(resp => {
					if (resp.code == 200) {
						let user = JSON.parse(window.localStorage.getItem("user"));
						user.image = resp.result;
						window.localStorage.setItem("user", JSON.stringify(user));
						this.loading = false;
						// this.$router.replace('/home');
						this.$store.commit('setImageUrl', resp.result);
					}

				});
				this.loading = false;
			},

		}
	};
</script>
<style scoped lang="scss">
	.user-info-head {
		position: relative;
		display: inline-block;
		height: 120px;
	}

	.user-info-head:hover:after {
		content: '+';
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		color: #eee;
		background: rgba(0, 0, 0, 0.5);
		font-size: 24px;
		font-style: normal;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		cursor: pointer;
		line-height: 110px;
		border-radius: 50%;
	}
</style>
